/**
 * @file paddle hack time line
 * @author wanzhongyun
 */

import {useCallback} from 'react';
import { RootObject, Content2 } from '../../type';

import './style.less';


const HackTimeLine = (props: RootObject["timeArrange"]) => {
    const {
        titleImg,
        backImg,
        years,
        describe,
        markImg,
        content
    } = props;
    const getSub = useCallback((content: Content2[]) => {
        const timeArray: string[] = [];
        content.forEach((value: Content2) => {
            timeArray.push(value.time)
        });
        const getCurrentTime = () => {
            const date = new Date();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            return `${month > 9 ? month : `0${month}`}.${day > 9 ? day : `0${day}`}`
        };
        // console.log(getCurrentTime());
        // console.log(timeArray.indexOf(getCurrentTime()));
        if (timeArray.indexOf(getCurrentTime()) === -1) {
            return 0;
        } else {
            return timeArray.indexOf(getCurrentTime());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [content]);

    return (
        <div className='paddle-hack-time-line-wrapper'>
            <div className="paddle-hack-time-line-content">
                <img className='paddle-hack-time-line-title' src={titleImg} alt='' />
                <div className='paddle-hack-time-line-header' style={{ backgroundImage: `url(${backImg})` }}>
                    <span>
                        {years ?? ""}
                    </span>
                    <span>
                        {describe ?? ""}
                    </span>
                </div>
                <div className='paddle-hack-time-line-bottom'>
                    {content?.map((value: Content2,index:number) => {
                        return (
                            <div className='bottom-li' key={index}>
                                <div className='li-content'>
                                    <div className='li-content-time'>
                                        {value.time ?? ""}
                                    </div>
                                    <div className='li-content-mark'>
                                        <div className="mark-wrapper">
                                            {/* <div className='mark-round'></div> */}
                                            {
                                                getSub(content) === index ?
                                                <div className="mark-back" style={{ backgroundImage: `url(${markImg})` }}></div>
                                                :
                                                <div className='mark-round'></div>

                                            }
                                            
                                        </div>
                                        <div className='li-line'></div>
                                    </div>
                                    <div className='li-content-desc'>
                                        <span>{value.title ?? ""}</span>
                                        <span>{value.describe ?? ""}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    );
};

export default HackTimeLine;